import React from 'react'
import { useSelector } from 'react-redux'
import useInput from '../hooks/input.hook'
import useFilter from '../hooks/filter.hook'

import Input from './UI/Input'
import Filter from './Filter'
import Amount from './UI/Amount'
import CardSelect from './CardSelect'


import * as filterSelectors from '../redux/selectors/filter.selectors'
import Select from './UI/Select'

const statusOption = [
    {value: 'WAIT', label: 'WAIT'},
    {value: 'CONFIRM', label: 'CONFIRM'}, 
    {value: 'REJECT', label: 'REJECT'}, 
    {value: null, label: 'All'}
]

function PaymentFilter() {
    const { setPaymentsFilter } = useFilter()

    const filter = useSelector(filterSelectors.payment)
    const id = useInput(filter.id, (value) => setPaymentsFilter({id: value}))
    const amount = { min: filter.amount.min, max: filter.amount.max }

    const filterOption = [
        { title: 'Status', elem: <Select option={statusOption} value={filter.status} handler={(option) => setPaymentsFilter({status: option.value})} placeholder="Status" /> },
        // { title: 'Card', elem: <CardSelect value={filter.card} handler={(values) => setPaymentsFilter({card: values})} /> },
        { title: 'Amount', elem: <Amount handler={(value) => setPaymentsFilter({amount: value})} value={amount} /> }
    ]

    return (
        <>
            <Filter option={filterOption} />
            <Input input={id} placeholder='id' />
        </>
    )
}

export default PaymentFilter